import React from 'react';
import {SliderItem, GetTrackProps} from 'react-compound-slider';

interface Props {
  source: SliderItem;
  target: SliderItem;
  getTrackProps: GetTrackProps;
  color?: string;
}

export default function Track({source, target, getTrackProps, color}: Props) {
  return (
    <div
      style={{
        position: 'absolute',
        height: 5,
        zIndex: 1,
        backgroundColor: color ? color : '#fff',
        cursor: 'pointer',
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
      }}
      {...getTrackProps()}
    />
  );
}
